<ul>
    <ng-container *ngFor="let sag of sager; trackBy: trackByPid">
        <li *ngIf="sag.lukket === false"
            class="nav-link"
            [ngClass]="{ 'selected': sag.pid.toString() === route.children[0]?.snapshot?.params?.sagid }"
            (click)="onOpenClientCase(sag)"
            placement="right"
            data-container="body"
            [ngbTooltip]="sidebarCollapsed ? tipContent : ''">
            <ng-template #tipContent>
                    {{sag.beskrivelse}}<br>
                    {{sag.fra | date:'dd-MM-yyyy'}} {{ sag.til != null ? '->' : '' }} {{sag.til | date:'dd-MM-yyyy'}}
            </ng-template>
            <ng-container *ngIf="!sag.v2RegnskabsaarKundeId">
                <i class="case__icon fa fa-file-text-o"></i>
                <span [ngClass]="sidebarCollapsed ? 'case__text--collapsed' : 'case__text--normal'">
                    <i class="fa fa-lock" title="Låst" *ngIf="sag.locked"></i> {{sag.beskrivelse}}<br/>
                    <small>{{sag.fra | date:'dd-MM-yyyy'}} {{ sag.til != null ? '->' : '' }} {{sag.til | date:'dd-MM-yyyy'}}</small>
                </span>
            </ng-container>
            <ng-container *ngIf="sag.v2RegnskabsaarKundeId">
                <i class="case__icon sag-status" [ngClass]="sag | sagStatusClass"></i>
                <span [ngClass]="sidebarCollapsed ? 'case__text--collapsed' : 'case__text--normal'">
                    {{sag.beskrivelse}}<br/>
                    <small>{{sag.fra | date:'dd-MM-yyyy'}} {{ sag.til != null ? '->' : '' }} {{sag.til | date:'dd-MM-yyyy'}}</small>
                </span>
            </ng-container>
        </li>
    </ng-container>
</ul>
